/**
 * Museo select — dropdown custom di atas <select> asli (semua perangkat).
 *
 * Pakai: tambahkan atribut data-mselect ke <select>. Select hasil render app (Judge.me sort) dan select yang
 * disisipkan belakangan (quick view) ikut ditangkap lewat MutationObserver.
 *
 * Select asli tetap dipakai: tampilan tertutupnya (styling section masing-masing), nilai form, validasi
 * `required`, dan event `change` yang sudah didengarkan kode lain. Yang diganti hanya popup pilihannya:
 * klik/tap/Enter/Space/panah membuka panel listbox bergaya Museo, bukan picker bawaan browser/OS.
 * Panel memakai popover (top layer) supaya tidak terpotong overflow section atau dialog quick view.
 */
(function () {
  if (window.MuseoSelect) return;

  var SELECTOR = 'select[data-mselect], .jdgm-sort-dropdown';
  var OPEN_KEYS = [' ', 'Enter', 'ArrowDown', 'ArrowUp', 'F4'];
  var supportsPopover = typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('popover');
  var reduced = function () { return matchMedia('(prefers-reduced-motion: reduce)').matches; };
  var uid = 0;
  var current = null; // { select, panel, items, active }

  function enhance(select) {
    if (!(select instanceof HTMLSelectElement) || select.multiple || select.dataset.mselectReady) return;
    select.dataset.mselectReady = '1';
    select.setAttribute('aria-haspopup', 'listbox');
    select.setAttribute('aria-expanded', 'false');

    // Desktop: mousedown yang dibatalkan tidak membuka popup bawaan.
    select.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      e.preventDefault();
      select.focus({ preventScroll: true });
      toggle(select);
    });
    // Sentuh: batalkan touchend (tanpa geser) → picker iOS/Android tidak muncul.
    var start = null;
    select.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      start = { x: t.clientX, y: t.clientY };
    }, { passive: true });
    select.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0];
      if (!start || Math.abs(t.clientX - start.x) > 10 || Math.abs(t.clientY - start.y) > 10) return;
      e.preventDefault();
      toggle(select);
    });
    select.addEventListener('keydown', function (e) {
      if (OPEN_KEYS.indexOf(e.key) === -1 && !(e.altKey && e.key === 'ArrowDown')) return;
      e.preventDefault();
      open(select);
    });
  }

  function toggle(select) {
    if (current && current.select === select) close(true);
    else open(select);
  }

  function open(select) {
    if (select.disabled) return;
    if (current) close(false);

    var panel = document.createElement('div');
    panel.className = 'mselect-panel';
    panel.id = 'mselect-' + ++uid;
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('tabindex', '-1');
    var label = select.labels && select.labels[0] ? select.labels[0].textContent.trim() : select.getAttribute('aria-label');
    if (label) panel.setAttribute('aria-label', label);
    var cs = getComputedStyle(select);
    panel.style.fontFamily = cs.fontFamily;
    panel.style.fontSize = cs.fontSize;
    panel.style.letterSpacing = cs.letterSpacing;

    var items = [];
    Array.prototype.forEach.call(select.options, function (opt, index) {
      // Placeholder ("Select One": value kosong + disabled) dan opsi tersembunyi tidak ditampilkan.
      if (opt.hidden || (opt.disabled && opt.value === '')) return;
      var item = document.createElement('div');
      item.className = 'mselect-option';
      item.id = panel.id + '-' + index;
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', String(index === select.selectedIndex));
      if (opt.disabled) item.setAttribute('aria-disabled', 'true');
      item.textContent = opt.textContent.trim();
      item.dataset.index = index;
      panel.appendChild(item);
      items.push(item);
    });
    if (!items.length) return;

    // Di dalam dialog modal, panel harus jadi turunan dialog (di luar dialog = inert).
    (select.closest('dialog[open]') || document.body).appendChild(panel);
    if (supportsPopover) {
      panel.setAttribute('popover', 'manual');
      panel.showPopover();
    }
    current = { select: select, panel: panel, items: items, active: -1 };
    position();

    var selected = items.findIndex(function (i) { return i.getAttribute('aria-selected') === 'true'; });
    setActive(selected > -1 ? selected : 0, true);
    select.setAttribute('aria-expanded', 'true');
    select.setAttribute('aria-controls', panel.id);
    panel.focus({ preventScroll: true });

    panel.addEventListener('click', function (e) {
      var item = e.target.closest('.mselect-option');
      if (item) choose(items.indexOf(item));
    });
    panel.addEventListener('pointermove', function (e) {
      var item = e.target.closest('.mselect-option');
      if (item && e.pointerType === 'mouse') setActive(items.indexOf(item), false);
    });
    panel.addEventListener('keydown', onPanelKey);

    if (!reduced() && panel.animate) {
      var up = panel.classList.contains('is-up');
      panel.animate(
        [{ opacity: 0, transform: 'translateY(' + (up ? 4 : -4) + 'px)' }, { opacity: 1, transform: 'none' }],
        { duration: 140, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
      );
    }
  }

  function position() {
    if (!current) return;
    var r = current.select.getBoundingClientRect();
    var panel = current.panel;
    var vw = document.documentElement.clientWidth;
    var vh = window.innerHeight;
    var gap = 4;
    panel.style.minWidth = r.width + 'px';
    panel.style.maxWidth = Math.max(r.width, Math.min(360, vw - 16)) + 'px';
    var below = vh - r.bottom - gap - 8;
    var above = r.top - gap - 8;
    var natural = Math.min(panel.scrollHeight, 300);
    var up = below < natural && above > below;
    panel.style.maxHeight = Math.max(120, Math.min(300, up ? above : below)) + 'px';
    panel.classList.toggle('is-up', up);
    var h = panel.offsetHeight;
    var w = panel.offsetWidth;
    panel.style.left = Math.max(8, Math.min(r.left, vw - w - 8)) + 'px';
    panel.style.top = (up ? r.top - gap - h : r.bottom + gap) + 'px';
  }

  function setActive(index, scroll) {
    if (!current || index < 0 || index >= current.items.length) return;
    current.items.forEach(function (item, i) { item.classList.toggle('is-active', i === index); });
    current.active = index;
    current.panel.setAttribute('aria-activedescendant', current.items[index].id);
    if (scroll) {
      var item = current.items[index];
      var p = current.panel;
      if (item.offsetTop < p.scrollTop) p.scrollTop = item.offsetTop;
      else if (item.offsetTop + item.offsetHeight > p.scrollTop + p.clientHeight) p.scrollTop = item.offsetTop + item.offsetHeight - p.clientHeight;
    }
  }

  function move(from, step) {
    var items = current.items;
    for (var i = from + step; i >= 0 && i < items.length; i += step) {
      if (items[i].getAttribute('aria-disabled') !== 'true') return i;
    }
    return from;
  }

  var typed = '';
  var typedAt = 0;

  function onPanelKey(e) {
    if (!current) return;
    var a = current.active;
    switch (e.key) {
      case 'ArrowDown': e.preventDefault(); setActive(move(a, 1), true); break;
      case 'ArrowUp': e.preventDefault(); setActive(move(a, -1), true); break;
      case 'Home': e.preventDefault(); setActive(move(-1, 1), true); break;
      case 'End': e.preventDefault(); setActive(move(current.items.length, -1), true); break;
      case 'Enter':
      case ' ': e.preventDefault(); choose(a); break;
      case 'Escape': e.preventDefault(); close(true); break;
      case 'Tab': close(true); break;
      default:
        if (e.key.length !== 1 || e.ctrlKey || e.metaKey || e.altKey) return;
        // Ketik huruf → lompat ke opsi yang diawali teks itu.
        var now = Date.now();
        typed = now - typedAt > 600 ? e.key.toLowerCase() : typed + e.key.toLowerCase();
        typedAt = now;
        var hit = current.items.findIndex(function (item) {
          return item.getAttribute('aria-disabled') !== 'true' && item.textContent.toLowerCase().indexOf(typed) === 0;
        });
        if (hit > -1) setActive(hit, true);
    }
  }

  function choose(index) {
    if (!current) return;
    var item = current.items[index];
    if (!item || item.getAttribute('aria-disabled') === 'true') return;
    var select = current.select;
    var next = Number(item.dataset.index);
    close(true);
    if (select.selectedIndex === next) return;
    select.selectedIndex = next;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function close(refocus) {
    if (!current) return;
    var c = current;
    current = null;
    c.select.setAttribute('aria-expanded', 'false');
    c.select.removeAttribute('aria-controls');
    if (supportsPopover && c.panel.matches(':popover-open')) c.panel.hidePopover();
    c.panel.remove();
    if (refocus) c.select.focus({ preventScroll: true });
  }

  document.addEventListener('pointerdown', function (e) {
    if (current && !current.panel.contains(e.target) && e.target !== current.select) close(false);
  }, true);
  window.addEventListener('resize', function () { close(false); });
  document.addEventListener('scroll', function (e) {
    if (!current || current.panel.contains(e.target)) return;
    position();
    var r = current.select.getBoundingClientRect();
    if (r.bottom < 0 || r.top > window.innerHeight) close(false);
  }, true);

  function scan(root) {
    if (root.matches && root.matches(SELECTOR)) enhance(root);
    if (root.querySelectorAll) root.querySelectorAll(SELECTOR).forEach(enhance);
  }

  function init() {
    scan(document);
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        r.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.MuseoSelect = { enhance: enhance, close: function () { close(false); } };
})();
